import type { ReactNode } from "react";
import { T } from "@freightsimple/ui-core/Typography/T";

export function QuotesLocationTypeDescription({
  children,
}: {
  children: ReactNode;
}) {
  return <T>{children}</T>;
}
